(() => {
  if (customElements.get('cross-sells')) {
    return;
  }

  class CrossSells extends HTMLElement {
    constructor() {
      super();
      this.sliderEl = this.querySelector('[data-slider]');

      this.sliderOptions = {
        spaceBetween: 8,
        breakpoints: {
          990: {
            spaceBetween: 16,
          },
        },
        noSwipingClass: 'no-swiping',
        navigation: {
          prevEl: this.querySelector('[data-prev-button]'),
          nextEl: this.querySelector('[data-next-button]'),
        },
      };

      if (this.dataset.variation === 'recharge') {
        this.sliderOptions.breakpoints = {
          990: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
        };
      }

      this.handleResize = this.debounce(() => {
        this.equalizeTitles();
      }, 100);
    }

    connectedCallback() {
      if (!this.sliderEl) {
        return;
      }
      this.initSlider();

      requestAnimationFrame(() => {
        this.equalizeTitles();
      });

      setTimeout(() => {
        this.equalizeTitles();
      }, 300);

      setTimeout(() => {
        this.equalizeTitles();
      }, 1000);

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    initSlider() {
      this.slider = new Swiper(this.sliderEl, this.sliderOptions);
    }

    equalizeTitles() {
      if (!this.closest('.cart-drawer__cross-sell--slider')) {
        return;
      }

      const titles = this.querySelectorAll('.js-card-title');

      if (!titles.length) return;

      titles.forEach((title) => {
        title.style.minHeight = '';
      });

      let maxHeight = 0;

      titles.forEach((title) => {
        maxHeight = Math.max(maxHeight, title.getBoundingClientRect().height);
      });

      titles.forEach((title) => {
        title.style.minHeight = `${maxHeight}px`;
      });
    }

    debounce(fn, delay) {
      let timer;

      return (...args) => {
        clearTimeout(timer);

        timer = setTimeout(() => {
          fn.apply(this, args);
        }, delay);
      };
    }
  }

  customElements.define('cross-sells', CrossSells);
})();
